<template>
<div>
    <div class="diagram-three-wrap" :style="{ height: winHeight - 100 + 'px' }" ref="total">
        <div id="main" ref="main" class="total-wrap">
            <div
                id="canvas"
                ref="canvas"
                class="canvas-wrap"
                :style="
                    `transform: scale(${scale});width:${width};height:${height};top:${top}px;left:${left}px`
                "
            >
                <img class="bg-img" src="../../../../assets/image/app/xbj-02.svg" alt srcset />
                <!-- <div class="total-title">MO3#变系统图</div> -->
                  <div
                        v-for="item in mo_datas"
                        :key="item.point_id"
                        class="data-wrap"
                        :style="`top:${item.top}%;left:${item.left}%;`"
                        @click="showDialog(item)"
                    >
                        <div class="data-item">
                            <div class="data-name red">ia</div>
                            <div class="data-number">
                                {{ item.ia }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name yellow">ib</div>
                            <div class="data-number">
                                {{ item.ib }}
                                <span>A</span>
                            </div>
                        </div>
                        <div class="data-item">
                            <div class="data-name green">ic</div>
                            <div class="data-number">
                                {{ item.ic }}
                                <span>A</span>
                            </div>
                        </div>
                    </div> 
                    <div
                        v-for="item in mo_datas"
                        :key="item.switch_id"
                        class="top-switch"
                        :style="`top:${item._top}%;left:${item._left}%;`"  @click="showTempDialog(item)"
                    >
                    <template v-if="item.isOn == 0">
                            <img
                               
                                src="../../../../assets/image/app/switch-on.svg"
                                alt
                                srcset
                                class="kaiguan"
                            />
                             </template>
                              <template v-else>
                                <img 
                                    src="../../../../assets/image/app/switch-off.svg"
                                    alt
                                    srcset
                                    class="kaiguan"
                                />
                            
                        </template>
                    </div>   
            </div>
        </div>
        <diagramDialog :dialogVisible.sync="dialogVisible" :id="data_id" />
        <diagramDialog :dialogVisible.sync="dialogTempVisible" :id="switch_power_id" />
    </div>
</div>
</template>
<script>

import diagramDialog from "./components/diagram-dialog.vue";
import * as api from "@/http/api-runtime.js";
import { getNewestPower } from "@/http/api";
export default {
    components: { diagramDialog },
    data() {
        return {
           left: "0",
            top: "-20",
            scale:1,
            width: 1200,
            height: 1000,
            winHeight: 0,
            dialogVisible: false,
            data_id: "",
            data_temp_id: "",
            switch_power_id: "",
            timer: null,
                mo_datas: [
                {
                    name: "402",
                    point_id: "1466603576397713408",
                   _top:11.5,
                    _left:3.8,
                    switch_id: "sunsu_000000000000079",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:2,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4201",
                    point_id: "1466604133468393472",
                    _top:11.5,
                    _left:11.35,
                    switch_id: "sunsu_000000000000080",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:9,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4202",
                    point_id: "1466604288573755392",
                     _top:11.5,
                    _left:16.78,
                    switch_id: "sunsu_000000000000081",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:14,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4203",
                    point_id: "1466604431247200256",
                      _top:11.5,
                    _left:22.53,
                   switch_id: "sunsu_000000000000082",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:19,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4204",
                    point_id: "1466604784093024256",
                     _top:11.5,
                    _left:27.13,
                   switch_id: "sunsu_000000000000083",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:24,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4205",
                    point_id: "1466608493006999552",
                    _top: 11.5,
                    _left:32.46,
                    switch_id: "sunsu_000000000000084",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:30,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "400",
                    point_id: "1466608651245506560",
                    _top:11.5,
                    _left:37.59,
                   switch_id: "sunsu_000000000000085",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:36,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4207",
                    point_id: "1466608892862582784",
                    _top: 11.5,
                    _left:50.59,
                   switch_id: "sunsu_000000000000086",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:48,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4208",
                    point_id: "1466609435370639360",
                    _top:11.5,
                    _left:56.01,
                    switch_id: "sunsu_000000000000087",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left: 53,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4209",
                    point_id: "1466609661452013568",
                    _top:11.5,
                    _left:61.99,
                    switch_id: "sunsu_000000000000088",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:59,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4210",
                    point_id: "1466609840838201344",
                    _top:11.5,
                    _left:67.78,
                    switch_id: "sunsu_000000000000089",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left: 66,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                  {
                    name: "4211",
                    point_id: "1466610113858031616",
                    _top:11.5,
                    _left:73.73,
                    switch_id: "sunsu_000000000000090",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top: 35,
                    left:72,
                    ia: "",
                    ib: "",
                    ic: ""
                }, 
                 {
                    name: "4212",
                    point_id: "1466610269076639744",
                     _top:11.5,
                    _left:80.09,
                    switch_id: "sunsu_000000000000091",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:78,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4213",
                    point_id: "1466610455421177856",
                     _top:11.5,
                    _left:87.03,
                    switch_id: "sunsu_000000000000092",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:84.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4214",
                    point_id: "1466610581652951040",
                     _top:11.5,
                    _left:92.83,
                    switch_id: "sunsu_000000000000093",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:35,
                    left:91,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4215",
                    point_id: "1466610731309912064",
                     _top:60,
                    _left:92.75,
                    switch_id: "sunsu_000000000000094",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:91,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4216",
                    point_id: "1466610872397910016",
                     _top:60,
                    _left:85.31,
                    switch_id: "sunsu_000000000000095",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                   top:82,
                    left:82,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4217",
                    point_id: "1466611016258342912",
                     _top:60,
                    _left:75.88,
                    switch_id: "sunsu_000000000000096",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                   top:82,
                    left:74,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                
                 {
                    name: "4218",
                    point_id: "1466611186081517568",
                     _top:60,
                    _left:69.18,
                    switch_id: "sunsu_000000000000097",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:67,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4219",
                    point_id: "1466611351290957824",
                    _top:60,
                    _left:63.28,
                    switch_id: "sunsu_000000000000098",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                     left:61,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4220",
                    point_id: "1466611887792771072", 
                    _top:60,
                    _left:57.48,
                    switch_id: "sunsu_000000000000099",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                     top:82,
                    left:55,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4221",
                    point_id: "1466612455424708608",
                    _top:60,
                    _left:50.85,
                   switch_id: "sunsu_000000000000100",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:48.5,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                  {
                    name: "4222",
                    point_id: "1466612602346983424",
                    _top:60,
                    _left:44.73,
                    switch_id: "sunsu_000000000000101",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:43,
                    ia: "",
                    ib: "",
                    ic: ""
                },{
                    name: "4223",
                    point_id: "1466612837446111232",
                    _top:60,
                    _left:36.95,
                    switch_id: "sunsu_000000000000102",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:35,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4224",
                    point_id: "1466613263289602048",
                    _top:60,
                    _left:30.65,
                    switch_id: "sunsu_000000000000103",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:28,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4225",
                    point_id: "1466613429132382208",
                    _top:60,
                    _left:24.3,
                    switch_id: "sunsu_000000000000104",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:22,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                {
                    name: "4226",
                    point_id: "1466613557696188416",
                    _top:60,
                    _left:17.9,
                    switch_id: "sunsu_000000000000105",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:15,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4227",
                    point_id: "1466613682854219776",
                    _top:60,
                    _left:11.29,
                    switch_id: "sunsu_000000000000106",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:9,
                    ia: "",
                    ib: "",
                    ic: ""
                },
                 {
                    name: "4228",
                    point_id: "1466613820632911872",
                    _top:60,
                    _left:4.0,
                    switch_id: "sunsu_000000000000107",
                    isOn: 1,  //1默认连通开  红色；  0断开  关绿色
                    top:82,
                    left:1,
                    ia: "",
                    ib: "",
                    ic: ""
                },
            ]

        };
    },
    created() {
        if (window.innerHeight) this.winHeight = window.innerHeight;
        else if (document.body && document.body.clientHeight)
            this.winHeight = document.body.clientHeight;
    },

    mounted() {
        this.zoom();
        this.drag();
         this.setTimer();
        // 获取mo实时电数据
        this.getMoElecData();
        // 获取mo实时温度数据
        //this.getMoTempData();
        
        //获取MO开关
        this.getWarnSwitch();
    },
     methods: {
          setTimer() {
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(() => {
                // 获取mo实时电数据
                this.getMoElecData();
                // 获取mo实时温度数据
              //  this.getMoTempData();
                
                 // 获取mo开关
                this.getWarnSwitch();
            }, 1000 * 60);
        },
        /**
        * @description: 获取mo实时电数据
        */
        getMoElecData() {
            let pointIds = [];
            this.mo_datas.forEach(item => {
                pointIds.push(item.point_id);
            });
            api.getDataAll(pointIds).then(res => {
                let valueJson = res.bus_json;
                this.mo_datas.forEach(item => {
                    let point = valueJson[item.point_id];
                    item.ia = point && point["a_a"] && this.fixedString(point["a_a"], 2);
                    item.ib = point && point["a_b"] && this.fixedString(point["a_b"], 2);
                    item.ic = point && point["a_c"] && this.fixedString(point["a_c"], 2);
                })
            })
        },
        //开关开关
   getWarnSwitch() {
            let powerIds = [];
            this.mo_datas.forEach(item => {
                powerIds.push(item.switch_id);
            });
            api.getWarnSwitch(powerIds).then(res => {
                let valueJson = res.bus_json; 
                this.mo_datas.forEach(item => { 
                 let point = valueJson[item.switch_id];
                  item.isOn = point && point["kgl"];
                })
            })
        }, 

        /**
        * @description: 获取mo实时温度数据
        */
        // getMoTempData() {
        //     let pointIds = [];
        //     this.temp_datas.forEach(item => {
        //         pointIds.push(item.point_id);
        //     });
        //     api.getDataAll(pointIds).then(res => {
        //         let valueJson = res.bus_json;
        //         this.temp_datas.forEach(item => {
        //             let point = valueJson[item.point_id];
        //             item.ta = point && point["t_a"] && this.fixedString(point["t_a"], 0);
        //             item.tb = point && point["t_b"] && this.fixedString(point["t_b"], 0);
        //             item.tc = point && point["t_c"] && this.fixedString(point["t_c"], 0);
        //         })
        //     })
        // },
    
        /**
        * @description: 保留几位小数  number位数
        */
        fixedString(value, number) {
            let val = value + "";
            if (number == 0) {
                const arr = val.split(".");
                if (arr.length > 0) {
                    return arr[0];
                } else {
                    return "";
                }
            }
            return val.substring(0, val.indexOf(".") + (1 + number));

        },
        showDialog(item) {
            this.dialogVisible = true;
            this.data_id = item.point_id;
        },
        showTempDialog(item) {
            this.dialogTempVisible = true;
            this.switch_power_id = item.switch_id;  
        },
        zoom() {
            let vm = this;
            if (navigator.userAgent.indexOf("Firefox") != -1) {
                //FF
                document.getElementById("main").addEventListener(
                    "DOMMouseScroll",
                    function (event) {
                        event = event || window.event;
                        if (event.detail > 0) {
                            vm.scale =
                                vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                        } else {
                            vm.scale += 0.1;
                        }
                        event.cancelBubble = true;
                        event.stopPropagation();
                        event.preventDefault();
                    },
                    false
                );
            } else {
                //非FF
                document.getElementById("main").onmousewheel = function (event) {
                    event = event || window.event;
                    if (event.deltaY > 0) {
                        vm.scale = vm.scale > 0.2 ? vm.scale - 0.1 : vm.scale;
                    } else {
                        vm.scale += 0.1;
                    }
                    event.cancelBubble = true;
                    event.stopPropagation();
                    event.preventDefault();
                };
            }
        },
        drag() {
            let oDiv = this.$refs.canvas;
            let vm = this;
            oDiv.onmousedown = function (en) {
                let ev = ev || event;
                let disX = en.clientX - oDiv.offsetLeft;
                let disY = en.clientY - oDiv.offsetTop;
                oDiv.onmousemove = function (en) {
                    let ev = ev || event;
                    if (
                        en.clientY > 0 &&
                        en.clientY < vm.$refs.main.clientHeight &&
                        en.clientX > 0 &&
                        en.clientX < vm.$refs.main.clientWidth
                    ) {
                        vm.top = en.clientY - disY;
                        vm.left = en.clientX - disX;
                    }
                };
                oDiv.onmouseup = function () {
                    oDiv.onmousemove = null;
                };
                return false;
            };
        },
    },
       destroyed() {
        clearInterval(this.timer);
    }
};
</script>
<style lang="scss" scoped>
.diagram-three-wrap {
    background-color: #09292f;
    width: 98%;
    overflow: hidden;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    .total-wrap {
        width: 100%;
        height: 100%;
        position: relative;
        cursor: move;
        .canvas-wrap {
            width: 100%;
            position: absolute;
            left: 0;
            top: 0;
             box-sizing: border-box;
            .bg-img {
                    width: 100%;
                    height: 100%;
                }
             }
              .top-switch {
               cursor: pointer;
                transform: scale(1);
                position: absolute;
                text-align: center;
                display: flex;
               // height: 20%;
                overflow: hidden;
                .top-title {
                    align-self: center;
                    margin-left: 0.7rem;
                    font-size: 0.8rem;
                }
            }
        .total-title {
            color: #fff;
            position: absolute;
            font-size: 24px;
            text-align: center;
            top: 1%;
            left: 50%;
            transform: translateX(-50%);
        }
        .bg-img {
            width: 100%;
        }
        .data-wrap {
            position: absolute;
            display: grid;
            transform: scale(0.8);
            cursor: pointer;
            .data-item {
                display: flex;
                margin-bottom: 0.3rem;
                .data-name {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                }
                .data-number {
                    font-size: 0.8rem;
                    width: 5rem;
                    text-align: right;
                     background-color: #0e4b69;
                    color: #fff;
                    height: 1.2rem;
                    line-height: 1.3rem;
                //  margin-left: 0.4rem;
                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                } 
                .red {
                    color: #fe0101;
                } 
                .yellow {
                    color: #fefa00;
                } 
                .green {
                    color: #00b200;
                }
            }
            .data-item-temp {
                display: flex;
                margin-bottom: 0.3rem; 
                .data-name-temp {
                    align-self: center;
                    font-size: 1rem;
                    margin-right: 0.1rem;
                    width: 1rem;
                    text-align: right;
                    font-weight: bold;
                } 
                .data-number-temp {
                    font-size: 0.8rem;
                    width: 5rem;
                    text-align: right;
                    // background-color: #114aa5;
                    color: #fff;
                    height: 1.2rem;
                    line-height: 1.2rem; 
                    .nowrap span {
                        display: inline-block;
                        margin-left: 0.2rem;
                        margin-right: 0.2rem;
                    }
                } 
                .red {
                    color: #fe0101;
                } 
                .yellow {
                    color: #fefa00;
                } 
                .green {
                    color: #00b200;
                }
            }
        }
    }
}
</style>
